// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./assets/index.less
// module id = 64
// module chunks = 0